import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Document, Page } from 'react-pdf';
import styles from './PdfDisplayTab.module.css'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

class PdfDisplayTab extends Component {

    renderDisplay() {
        if (this.props.loading) {
            return (<div ><i>Loading...</i></div>);
        } else if (!this.props.loading && this.props.pdfData) {
            return (<div>

                <Document
                    file={{ data: this.props.pdfData }}
                >
                    {[...Array(this.props.numPages).keys()].map(page => (
                        <div key={page} style={{ paddingBottom: '15px' }}>
                            <Page width={725} pageNumber={page + 1} />
                        </div>
                    ))}
                </Document>
            </div>)
        }
    }

    render() {
        return (
            <div className={styles.pdf_wrapper} >
                {this.renderDisplay()}
            </div>
        );
    }
}

function mapStateToProps(state) {
    var pdfData = undefined;
    var numPages = 0;
    if (state.entities.pdfs && state.entities.pdfs[state.ui.notesReqApproval.selectedMessage]) {
        pdfData = state.entities.pdfs[state.ui.notesReqApproval.selectedMessage].pdfData;
        numPages =state.entities.pdfs[state.ui.notesReqApproval.selectedMessage].numPages;
    }

    return {
        pdfData: pdfData,
        loading: state.ui.pdfs.loading,
        numPages: numPages
    };
}

const connectedPdfDisplayTab = connect(mapStateToProps)(PdfDisplayTab);
export { connectedPdfDisplayTab as PdfDisplayTab };
